import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full flex justify-center items-center"
}
const _hoisted_2 = {
  key: 2,
  class: "flex items-center justify-center h-full pb-10 text-base text-gray-900 dark:text-dark-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (_ctx.courseHeatMapPresenter.isPlotting.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingPanel)
      ]))
    : (_ctx.courseHeatMapPresenter.hasData.value)
      ? (_openBlock(), _createBlock(_component_VueApexCharts, {
          key: 1,
          class: "pt-4 mx-4",
          height: "90%",
          options: _ctx.courseHeatMapPresenter.chartOptions.value,
          series: _ctx.courseHeatMapPresenter.heatMapSeries.value,
          type: "heatmap",
          onClick: _ctx.courseHeatMapPresenter.clickElement
        }, null, 8, ["options", "series", "onClick"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('message.noData')), 1))
}